<template>
<div class="wrap">
    <div class="con">
        <div class="left-templet" v-show="!isInit">
            <ul v-if="category === 'A'">
                <!-- 해당 페이지에 들어오면 li class="on" 되도록 해주세요!  -->
                <li class="pointer" v-if="viewProgress('input')" @click="step('input')" :class="{'on' : progressStyle('/admin/reg/input')}">
                    <a>신청 개요 <br> Access Code</a>
                </li>
                <li class="pointer" v-if="viewProgress('agree')" @click="step('agree')" :class="{'on' : progressStyle('/admin/reg/agree')}">
                    <a>신청 동의</a>
                </li>
                <li class="pointer" v-if="viewProgress('info')" @click="step('info')" :class="{'on' : progressStyle('/admin/reg/info')}">
                    <a>신청 안내</a>
                </li>
                <li class="pointer" v-if="viewProgress('enroll')" @click="step('enroll')" :class="{'on' : progressStyle('/admin/reg/enroll')}">
                    <a>프로그램 등록</a>
                </li>
                <li class="pointer" v-if="viewProgress('userInfo')" @click="step('userInfo')" :class="{'on' : progressStyle('/admin/reg/userInfo')}">
                    <a>신청자 정보</a>
                </li>
                <li class="pointer" v-if="viewProgress('purchase')" @click="step('purchase')" :class="{'on' : progressStyle('/admin/reg/purchase')}">
                    <a>결제 방식</a>
                </li>
                <li class="pointer" v-if="viewProgress('complete')" @click="step('complete')" :class="{'on' : progressStyle('/admin/reg/complete')}">
                    <a>신청완료</a>
                </li>
                <li class="pointer" v-if="viewProgress('setPopup')" @click="step('setPopup')" :class="{'on' : progressStyle('/admin/reg/setPopup')}">
                    <a>팝업설정</a>
                </li>
            </ul>
            <ul v-else-if="category === 'B'">
                <!-- 해당 페이지에 들어오면 li class="on" 되도록 해주세요!  -->
                <li class="pointer" v-if="viewProgress('input')" @click="step('input')" :class="{'on' : progressStyle('/admin/reg/input')}">
                    <a>신청 개요 <br> Access Code</a>
                </li>
                <li class="pointer" v-if="viewProgress('agree')" @click="step('agree')" :class="{'on' : progressStyle('/admin/reg/agree')}">
                    <a>신청 동의</a>
                </li>
                <li class="pointer" v-if="viewProgress('enroll')" @click="step('enroll')" :class="{'on' : progressStyle('/admin/reg/enroll')}">
                    <a>프로그램 등록</a>
                </li>
                <li class="pointer" v-if="viewProgress('info')" @click="step('info')" :class="{'on' : progressStyle('/admin/reg/info')}">
                    <a>신청 안내</a>
                </li>
                <li class="pointer" v-if="viewProgress('userInfo')" @click="step('userInfo')" :class="{'on' : progressStyle('/admin/reg/userInfo')}">
                    <a>신청자 정보</a>
                </li>
                <li class="pointer" v-if="viewProgress('purchase')" @click="step('purchase')" :class="{'on' : progressStyle('/admin/reg/purchase')}">
                    <a>결제 방식</a>
                </li>
                <li class="pointer" v-if="viewProgress('complete')" @click="step('complete')" :class="{'on' : progressStyle('/admin/reg/complete')}">
                    <a>신청완료</a>
                </li>
                <li class="pointer" v-if="viewProgress('setPopup')" @click="step('setPopup')" :class="{'on' : progressStyle('/admin/reg/setPopup')}">
                    <a>팝업설정</a>
                </li>
            </ul>
            <ul v-else-if="category === 'C'">
                <!-- 해당 페이지에 들어오면 li class="on" 되도록 해주세요!  -->
                <li class="pointer" v-if="viewProgress('input')" @click="step('input')" :class="{'on' : progressStyle('/admin/reg/input')}">
                    <a>신청 개요 <br> Access Code</a>
                </li>
                <li class="pointer" v-if="viewProgress('agree')" @click="step('agree')" :class="{'on' : progressStyle('/admin/reg/agree')}">
                    <a>신청 동의</a>
                </li>
                <li class="pointer" v-if="viewProgress('userInfo')" @click="step('userInfo')" :class="{'on' : progressStyle('/admin/reg/userInfo')}">
                    <a>신청자 정보</a>
                </li>
                <li class="pointer" v-if="viewProgress('info')" @click="step('info')" :class="{'on' : progressStyle('/admin/reg/info')}">
                    <a>신청 안내</a>
                </li>
                <li class="pointer" v-if="viewProgress('enroll')" @click="step('enroll')" :class="{'on' : progressStyle('/admin/reg/enroll')}">
                    <a>프로그램 등록</a>
                </li>
                <li class="pointer" v-if="viewProgress('purchase')" @click="step('purchase')" :class="{'on' : progressStyle('/admin/reg/purchase')}">
                    <a>결제 방식</a>
                </li>
                <li class="pointer" v-if="viewProgress('complete')" @click="step('complete')" :class="{'on' : progressStyle('/admin/reg/complete')}">
                    <a>신청완료</a>
                </li>
                <li class="pointer" v-if="viewProgress('setPopup')" @click="step('setPopup')" :class="{'on' : progressStyle('/admin/reg/setPopup')}">
                    <a>팝업설정</a>
                </li>
            </ul>
        </div>
        <keep-alive>
            <router-view />
        </keep-alive>
    </div>
</div>
</template>

<script>
export default {
    data: () => ({
        isInit: false,
        category: 'A', // 카테고리 A, B, C 유형 존재
        progressOrder: [], // 프로그래스 순서 배열 
        pageType: '' // 페이지 타입
    }),

    watch: {
        // 등록 페이지 내의 현재 라우터 경로 감지
        '$route'(to) {
            this.showProgress(to.fullPath)
        }
    },

    created() {
        this.category = sessionStorage.getItem('category')
        this.showProgress(this.$route.fullPath)
    },

    mounted() {
        
    },

    beforeDestroy() {
        // sessionStorage.removeItem('fix')
        // sessionStorage.removeItem('step')
        // sessionStorage.removeItem('category')
        // sessionStorage.removeItem('pOrder')
        // sessionStorage.removeItem('pageIdx')
        // sessionStorage.removeItem('mainIdx')
        // sessionStorage.removeItem('programIdx')
    },

    methods: {
        //  URL에 따라서 진행 단계 태그 출력 / 미출력 하기 위함
        showProgress(path) {
            console.log('path', path)
            // 등록과 수정시 sessionStorage 세팅
            if (sessionStorage.getItem('fix')) {
                if (path === '/admin/reg/init') {
                    this.isInit = true
                } else {
                    this.isInit = false
                }

                this.progressOrder = JSON.parse(sessionStorage.getItem("pOrder"))
                var pathArray = this.$route.fullPath.split('/')
                var length = pathArray.length
                this.pageType = pathArray[length - 1]
                sessionStorage.setItem('step', this.pageType)
                this.$router.push(path)
            } else {
                this.category = sessionStorage.getItem('category')
                if (path === '/admin/reg/init') {
                    this.isInit = true
                } else {
                    this.isInit = false
                    var pathArray = this.$route.fullPath.split('/')
                    var length = pathArray.length
                    this.pageType = pathArray[length - 1]

                    // this.setOrder()
                    this.progressOrder = JSON.parse(sessionStorage.getItem("pOrder"))
                    if (this.progressOrder.indexOf(this.pageType) > this.progressOrder.indexOf(sessionStorage.getItem('step'))) {
                        alert('이전 과정을 먼저 진행해 주세요. \n마지막으로 진행했던 과정으로 돌아갑니다.')
                        if (sessionStorage.getItem('step')) {
                            this.$router.push(`/admin/reg/${sessionStorage.getItem('step')}`)
                        } else {
                            this.$router.push('/admin/reg/init')
                        }
                        return false
                    }
                }
            }
        },

        // 선택한 페이지 과정만 출력되게
        viewProgress (type) {
            console.log('this.progressOrder', this.progressOrder)
            console.log('type', type)
            console.log('this.progressOrder.includes(type)', this.progressOrder.includes(type))
            return this.progressOrder.includes(type)
        },

        // 수강신청 등록 각 페이지에 대한 css class 적용
        progressStyle(path) {
            if (path === this.$route.fullPath) {
                return true
            } else {
                return false
            }
        },

        // 각 등록의 상세 페이지로 라우팅 (데이터 보존 O)
        movePage(path) {
            this.$router.push(path)
        },

        // 각 단계로 이동
        step(position) {
            console.log(this.progressOrder.indexOf(position))
            console.log(this.progressOrder.indexOf(this.pageType))
            if (sessionStorage.getItem('fix')) {
                this.$router.push(`/admin/reg/${position}`)
                return false
            }
            if (this.progressOrder.indexOf(position) > this.progressOrder.indexOf(sessionStorage.getItem('step'))) {
                alert('이전 과정을 먼저 진행해 주세요.')
                return false
            } else {
                this.$router.push(`/admin/reg/${position}`)
            }
        },

        // 카테고리에 따른 프로그레스 순서 정해주는 함수
        setOrder() {
            if (this.category === 'A') {
                this.progressOrder = ['input', 'agree', 'info', 'enroll', 'userInfo', 'purchase', 'complete', 'setPopup']
            } else if (this.category === 'B') {
                this.progressOrder = ['input', 'agree', 'enroll', 'info', 'userInfo', 'purchase', 'complete', 'setPopup']
            } else {
                this.progressOrder = ['input', 'agree', 'userInfo', 'info', 'enroll', 'purchase', 'complete', 'setPopup']
            }
            sessionStorage.setItem('pOrder', JSON.stringify(this.progressOrder))
        }
    }
}
</script>

<style scoped>
.active {
    font-weight: bold;
}
</style>
